import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import './Pages.css';

function Bookings({ apiUrl, token }) {
  const [bookings, setBookings] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    axios
      .get(`${apiUrl}/bookings`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => setBookings(res.data))
      .catch(() => setError('Failed to fetch bookings'));
  }, [apiUrl, token]);

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>My Bookings</h1>
        <Link to="/booking" className="btn btn-primary">+ Book a Session</Link>
      </div>

      {error && <div className="error-message">{error}</div>}

      <div className="list-container table-wrap">
        {bookings.length > 0 ? (
          <table className="table">
            <thead>
              <tr>
                <th>Service</th>
                <th>Practitioner</th>
                <th>Date</th>
                <th>Status</th>
                <th>Price</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {bookings.map((booking) => (
                <tr key={booking.id}>
                  <td>{booking.service_name}</td>
                  <td>{booking.practitioner_name}</td>
                  <td>{new Date(booking.booking_date).toLocaleDateString()}</td>
                  <td><span className={`badge badge-${booking.status}`}>{booking.status.replace('_', ' ')}</span></td>
                  <td>${parseFloat(booking.price).toFixed(2)}</td>
                  <td>
                    <Link to={`/bookings/${booking.id}`} className="btn btn-secondary btn-sm">
                      {booking.status === 'awaiting_payment' ? 'Pay Now' : 'View'}
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="empty-state">No bookings yet. <Link to="/booking">Book your first session</Link>.</p>
        )}
      </div>
    </div>
  );
}

export default Bookings;
